import i18n from 'i18next';

import ns1 from '../src/locales/en.json';
import {initReactI18next} from 'react-i18next';

export const defaultNS = 'ns1';
export const resources = {
  en: {
    ns1
  },
} as const;

i18n.use(initReactI18next).init({
  lng: 'en',
  ns: ['ns1'],
  returnNull: false,
  defaultNS,
  resources,
} as any);

export default i18n;
